const Snackbar = ({ open, children }) => {
    return (
        <div
            className={`fixed right-1/2 translate-x-1/2 bottom-6 shadow-sf-medium ${
                open ? 'visible' : 'invisible'
            } duration-300`}>
            <div className={`${open ? 'opacity-100' : 'opacity-0'} duration-300`}>{children}</div>
        </div>
    );
};

export default Snackbar;
